import {
    app,
    Component,
    ojs,
    each,
    state,
    component,
    payload,
} from "modular-openscriptjs";
import {
    empty,
    isMobile,
    pageInfo,
    scrollToTop,
    searchPlaceholder,
} from "../../../helpers";
import { api, dc } from "../../../declarations";
import Loader from "../../Blocks/Loader";
import SearchResultProductView from "../../Views/SearchResultProductView";
import { $e } from "../../../ojs.events";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(Loader, SearchResultProductView);

export default class CategoryProductsDefault extends Component {
    category = state({});
    subcategories = state([]);

    constructor() {
        super();
        this.category.listener(this);
        this.subcategories.listener(this);
    }

    render(...args) {
        pageInfo(this.category.value?.name || "Category");
        scrollToTop();

        if (empty(this.category.value)) {
            return h.Loader("dots");
        }

        let activeSubcategories = (this.subcategories?.value || []).filter(
            (sub) => (sub.products || []).length > 0,
        );

        return h.div(
            {
                class: "pt-3 pb-5 container mb-5 py-md-5",
            },

            h.h2({ class: "fw-bold mb-4 px-1" }, this.category.value?.name),

            activeSubcategories.length > 0
                ? each(activeSubcategories, (subcategory) =>
                      h.div(
                          { class: "mb-5" },
                          h.div(
                              {
                                  class: "d-flex justify-content-between align-items-center mb-3 px-1",
                              },
                              h.h4({ class: "fw-bold m-0" }, subcategory.name),
                              h.span(
                                  {
                                      class: "text-primary fw-bold cursor-pointer",
                                      role: "button",
                                      listeners: {
                                          click: () => {
                                              dc.currentCategory = subcategory;
                                              app("router").to(
                                                  "category.all-products",
                                                  {
                                                      categoryId:
                                                          subcategory.id,
                                                  },
                                              );
                                          },
                                      },
                                  },
                                  "Browse All",
                              ),
                          ),

                          h.div(
                              {
                                  class: "d-flex flex-nowrap overflow-x-auto pb-3 gap-3 desktop-scrollbar",
                              },
                              subcategory.products.map((product) =>
                                  h.SearchResultProductView(product, {
                                      class: "flex-shrink-0 h-100",
                                      style: isMobile()
                                          ? "width: 180px;"
                                          : "width: 280px;",
                                      listeners: {
                                          click: () => {
                                              broker.send(
                                                  app("$e").product.needs
                                                      .display,
                                                  payload({ product }),
                                              );
                                          },
                                      },
                                  }),
                              ),
                          ),
                      ),
                  )
                : h.div(
                      {
                          class: "card border-0 rounded-4 w-100 p-5 text-center bg-white shadow-sm border border-light",
                      },
                      h.div(
                          {
                              class: "text-muted d-flex flex-column align-items-center justify-content-center gap-3",
                          },
                          h.i({
                              class: "bi bi-folder2-open fs-1 text-secondary opacity-50",
                          }),
                          h.h5(
                              { class: "fw-bold text-dark mb-0" },
                              "No products in this category yet.",
                          ),
                      ),
                  ),

            ...args,
        );
    }

    $_mounted(componentId) {
        let c = component(componentId);

        if (!c) return;

        c.getData();
    }

    async getData() {
        const categoryId = router.params.categoryId;

        let res = await api.get(
            `/categories/${categoryId}/subcategories-with-products`,
        );

        if (!res) return;

        this.category.value = res.data.category;
        this.subcategories.value = res.data.subcategories;

        searchPlaceholder("Search in " + this.category.value?.name);
    }
}

ojs(CategoryProductsDefault);
